import { GetterTree, MutationTree, ActionTree } from 'vuex';
import { RootState } from '@/store'

export interface CommonState {
  drawer: boolean;
  mini: string|boolean;
  snackbar: object;
}

const state: CommonState = {
  drawer: true,
  mini: localStorage.getItem('drawerMini') == 'true' || false,
  snackbar: {
    value: false,
    multiLine: false,
    text: '',
    buttonColor: 'primary'
  }
}

const mutations: MutationTree<CommonState> = {
  TOGGLE_DRAWER (state) {
    state.drawer = !state.drawer
  },
  TOGGLE_MINI (state) {
    localStorage.setItem('drawerMini', ''+!state.mini)
    state.mini = !state.mini
  },
  SET_SNACKBAR (state, payload) {
    state.snackbar = {
      ... state.snackbar,
      payload
    }
  },
}

const actions: ActionTree<CommonState, any> = {
  toggleDrawer ({ commit }) {
    commit('TOGGLE_DRAWER')
  },
  toggleMini ({ commit }) {
    commit('TOGGLE_MINI')
  },
  setSnackbar ({ commit }, data) {
    commit('SET_SNACKBAR', data)
  }
}

const getters: GetterTree<CommonState, RootState> = {
  getDrawer: (state: any) => {
    return state.drawer
  },
  getMini: (state: any) => {
    return state.mini
  },
  getSnackbar: (state: any) => {
    return state.snackbar
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
